import React, {useEffect, useState} from "react";
import axios from "axios";
import {serverLink} from "../../../resources/url";
import Select from "react-select";

function StudentSelectOption(props) {
    const [IsLoading, setIsLoading] = useState(true)
    const [itemData, setItemData] = useState([])
    const [formData, setFormData] = useState({
        Item: "",
        ItemObject: "",
    })
    const getData = async () => {
        await axios.get(`${serverLink}staff/academics/student/option/list`)
            .then((result) => {
                let rows = [];
                if (result.data.length > 0) {
                    result.data.map((row) => {
                        rows.push({ value: row.STUDENTID, label: row.FIRST_NAME +" "+ row.MIDDLE_NAME  +" "+ row.LAST_NAME +" ("+row.STUDENTID+")" })
                    });
                    setItemData(rows);
                }
                setIsLoading(false)
            })
            .catch((err) => {
                console.log("NETWORK ERROR");
            });
    }
    useEffect(()=> {
        getData();
    }, [""])

    const onItemChange = (e) => {
        props.setFormData({
            ...props.formData,
            STUDENTID:e.value,
        })
        setFormData({
            ...formData,
            Item: e.value,
            ItemObject: e,
        })
    }

    return (
        <Select
            name="STUDENTID"
            value={!props.formData.STUDENTID ? formData.ItemObject : itemData.filter((e,i)=> e.value.toString() === props.formData.STUDENTID.toString())[0]}
            onChange={onItemChange}
            options={itemData}
            placeholder="Select Student"
        />
    )
}

export default StudentSelectOption;